import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const ProjectManagementSuite = () =>{
    return(
        <>
        <WrapperLayout>
            <Main/>
        </WrapperLayout>
    </>
    )
}
export default ProjectManagementSuite